import { AbstractControl } from '@angular/forms';

export function RangeValidator(min: number, max: number, field?: string) {
  return (c: AbstractControl) => {
    const controlValue = parseFloat(field ? c.value[field] : c.value);

    if (controlValue < min || controlValue > max) {
      return {
        rangeMin: controlValue < min,
        rangeMax: controlValue > max,
        range: true
      };
    }

    return null;
  };
}
